(function(){
  const popupClosed = Cookies.get('miyoshi_top_popup_closed')
  const popupEl = document.querySelector('.js-custom-top-popup')
  if (!popupClosed && popupEl) {
    popupEl.classList.add('is-active')
    const popupCloseBtns = document.querySelectorAll('.js-custom-top-popup-close')
    popupCloseBtns.forEach(function(btn) {
      btn.addEventListener('click', function(){
        popupEl.classList.remove('is-active')
        Cookies.set('miyoshi_top_popup_closed', 'true', { expires: 1 })
      })
    })

    const popupLink = document.querySelector('.js-custom-top-popup-link')
    popupLink.addEventListener('click', function(){
      Cookies.set('miyoshi_top_popup_closed', 'true', { expires: 1 })
      window.location.href = '/account/register'
    })
  }
})()